import { Injectable } from "@angular/core";
import { MapHelperService } from "../../../../../../services/map-helper.service";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { environment } from "../../../../../../environments/environment";
import { Subject, Subscription } from "rxjs";
import { LayerDTO } from "../models/LayerDTO";
import { EnumLayerTypes } from "../../../../shared/helpers/enums/EnumLayerTypes";
import { LocationCategoriesService } from "./LocationCategories.service";
import { LayerService } from "./Layers.service";
import { LocationsService } from "./Locations.service";
import { LayerGroup } from "../models/LayerGroups";
@Injectable({
  providedIn: "root",
})
export class GeneratedLayerService {

  capas = new Array<LayerGroup>();
  private capas$: Subject<LayerGroup[]> = new Subject<LayerGroup[]>();

  isGeneratedLayersExpanded: boolean = true;

  constructor(
    private mapHelper: MapHelperService
  ) {

  }
  
  setCapas(cap: LayerGroup[]) {
    this.capas = cap;
    this.capas$.next(this.capas);
  }
  
  getGroupLayers(): any {
    return this.capas$.asObservable();
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(layerGroupName : string, layerName: string) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    const filteredLayer = filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; });
    if (filteredLayer != undefined) {
      if (!filteredLayer.checked || filteredLayer.checked == null) {
        this.ActivateLayer(layerGroupName, layerName);
      } else {
        this.DeactivateLayer(layerGroupName, layerName);
      }
    }else{
      if(!environment.production) console.log("Undefined filteredSystemLayer");
    }
  }

  ActivateLayer(layerGroupName : string, layerName: string) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    const filteredLayer = filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; });
    if (filteredLayer != undefined) {
      filteredLayer.mapSourceId.forEach(element => {
        this.mapHelper.ShowLayersBySource(element);
      });
      filteredLayer.checked = true;
    }
  }

  DeactivateLayer(layerGroupName : string, layerName: string) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    const filteredLayer = filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; });
    if (filteredLayer != undefined) {
      filteredLayer.mapSourceId.forEach(element => {
        this.mapHelper.HideLayersBySource(element);
      });
      filteredLayer.checked = false;
    }
  }

  DeactivateAllLayers(){
    this.capas.forEach((layerGroup) => {
      layerGroup.layerList.forEach((layer) => {
        this.DeactivateLayer(layerGroup.name, layer.name);
      });
    });
  }

  GetSelectedLayers(){
    return this.capas.filter((layerGroup) => {
      return layerGroup.layerList.some((layer) => layer.checked);
    });
  }

  setLayerLoading(layerGroupName : string, layerName: string, isLoading: boolean) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    const filteredLayer = filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; });
    if (filteredLayer != undefined) {
      filteredLayer.isLoading = isLoading;
      this.capas$.next(this.capas);
    }
  }

  createLayer(layerGroupName : string, layerName: string, mapSourceId: string[], isChecked: boolean = true) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    if (filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; }) != undefined) {
      if(!environment.production) console.log("Layer already exists: " + layerName);
      return;
    }
    var layerDTO = new LayerDTO();
      layerDTO.name = layerName;
      layerDTO.icon = "";
      layerDTO.idLayerType = EnumLayerTypes.Point;
      layerDTO.atributeDisplay = "";
      layerDTO.categoryId = 0;
      layerDTO.isVisible = true;
      layerDTO.checked = isChecked;
      layerDTO.isLoading = false;
      layerDTO.itWorksAsVirtualLocation = false;
      layerDTO.mapSourceId = mapSourceId;

      if (filteredLayerGroup != undefined) {
        filteredLayerGroup.layerList.push(layerDTO);
      }else{
        const newLayerGroup = new LayerGroup();
        newLayerGroup.name = layerGroupName;
        newLayerGroup.isGeneratedLayerGroupExpanded = true;
        newLayerGroup.layerList = [layerDTO];
        this.capas.push(newLayerGroup);
      }

      //añade capa al array de capas
      this.capas$.next(this.capas);
  }

  deleteLayer(layerGroupName : string, layerName: string) {
    const filteredLayerGroup = this.capas.find((value) => { return value.name == layerGroupName; });
    const filteredLayer = filteredLayerGroup?.layerList.find((value) => { return value.name == layerName; });
    if (filteredLayer != undefined) {
      filteredLayer.mapSourceId.forEach(element => {
        this.mapHelper.ShowLayersBySource(element);
      });

      const newFiltersLayersInGroup = filteredLayerGroup?.layerList.filter((value) => { return value.name != layerName });
      if (newFiltersLayersInGroup != undefined && newFiltersLayersInGroup.length > 0) {
        filteredLayerGroup.layerList = newFiltersLayersInGroup;
      } else {
        this.capas = this.capas.filter((value) => { return value.name != layerGroupName; });
      }

      this.capas$.next(this.capas);
    }
  }

}
